import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
import { resetListProgramsData }  from 'entities/insurance-programs/index'
export const fetchProgramsList = createAsyncThunk(
    'contract/fetchProgramsList',
    async ({ contractID, sortArray, isReset }: {
        contractID: string[],
        sortArray: string[] | [],
        isReset?: boolean
    }, { dispatch, rejectWithValue }) => {
        try {
            const requestBody = {
                "Limit": 100000000000,
                "Offset": 0,
                ...(contractID.length > 0 && { "ContractIDs": contractID }),
                "SortableColumns": sortArray
            };
            if (isReset) {
                dispatch(resetListProgramsData());
            }
            const response = await getRequest(requestBody, 'dms-hr', 'getProgramsList', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { list: data.Programs, programCount: data.ProgramCount, fetchTime: parseToTimestamp(new Date()), contractID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);
